import { Injectable, inject } from '@angular/core';
import { HttpRequest } from '@angular/common/http';
import { Router } from '@angular/router';
import { LoginHelper } from '../helpers/login.helper';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root',
})
export class AuthSessionService {
  private static redirectScheduled = false;

  private readonly loginHelper = inject(LoginHelper);
  private readonly router = inject(Router);
  private readonly authService = inject(AuthService);

  shouldBypassUnauthorizedHandling(req: HttpRequest<unknown>): boolean {
    const url = req.url.toLowerCase();
    const publicAuthPaths = [
      '/api/auth/login/signin',
      '/api/auth/cadastrar/signup',
      '/api/auth/enviaremailesquecisenha/forgot-password',
      '/api/auth/alterarsenha/reset-password',
      '/api/auth/verificarusuarioemail',
      '/api/auth/verify-email-send',
    ];
    return publicAuthPaths.some((p) => url.includes(p));
  }

  forceReloginAfterUnauthorized(req: HttpRequest<unknown>): void {
    if (AuthSessionService.redirectScheduled) {
      return;
    }
    if (this.shouldBypassUnauthorizedHandling(req)) {
      return;
    }

    const session = this.loginHelper.get();
    if (!session?.token?.trim()) {
      return;
    }

    AuthSessionService.redirectScheduled = true;
    this.loginHelper.clearSession();
    this.authService.markLoggedOut();

    const ts = Date.now();
    const urlTree = this.router.createUrlTree(['/login'], {
      queryParams: { session: 'expired', ts },
    });
    const relative = this.router.serializeUrl(urlTree);
    window.location.assign(relative);
  }
}
